import { useGetCurrentSDUIClientSize } from "@faire/retailer/components/SDUI/__internal__/Viewport/useGetCurrentSDUIClientSize";

import { SDUIUPLTComponentsPerClientSize } from "./calculateNumComponentsPerClientSize";

export const useNumComponentsByClientSize = (
  numberOfComponentsByClientSize?: SDUIUPLTComponentsPerClientSize
) => {
  const sduiClientSize = useGetCurrentSDUIClientSize();
  if (!numberOfComponentsByClientSize) {
    return Infinity;
  }
  return numberOfComponentsByClientSize[sduiClientSize];
};
